import React from "react";
import CustomModal from "../../modals/CustomModal"; // Ajustá la ruta si hace falta
import CustomDataGrid from "../../CustomDataGrid";
import { Box, Typography } from "@mui/material";

const ModalHistorialValores = ({ open, onClose, historial = [] }) => {
  const columnsObject = [
    { field: "lista", headerName: "Lista", width: 120 },
    {
      field: "codigo_nomenclador",
      headerName: "Código",
      width: 100,
      renderCell: (params) => (
        <div style={{ fontWeight: "bold" }}>{params.value}</div>
      ),
    },
    {
      field: "descripcion_nomenclador",
      headerName: "Descripción",
      width: 200,
      textTransform: "capitalize",
    },
    {
      field: "vigencia",
      headerName: "Vigencia",
      width: 120,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "valor",
      headerName: "Valor",
      width: 150,
      align: "right",
      headerAlign: "right",
      renderCell: (params) => (
        <div style={{ width: "100%", textAlign: "right", fontWeight: "bold" }}>
          ${params.value}
        </div>
      ),
    },
  ];
  const viewportHeight = window.innerHeight;
  const gridHeight = viewportHeight - 180;

  return (
    <CustomModal
      open={open}
      onClose={onClose}
      title="Historial de Valores"
      width="60%"
      maxWidth="false"
      height={90}
    >
      {historial.length > 0 ? (
        <CustomDataGrid
          dataRows={historial}
          columnsObject={columnsObject}
          getRowId={(row) => `${row.codigo_nomenclador}-${row.vigencia}`}
          height={gridHeight}
        />
      ) : (
        <Box p={2}>
          <Typography variant="body1">
            No se encontraron valores históricos.
          </Typography>
        </Box>
      )}
    </CustomModal>
  );
};

export default ModalHistorialValores;
